module.exports = __webpack_public_path__ + "static/desktop-9f784bca5d7d441e4f95aef86efe9a55.jpg";